import { Injectable } from '@angular/core';
import { GenericServicesMotoristaService } from './generic-services-motorista.service';
import { MensagensService } from 'max-ng-lib';
import { HttpClient } from '@angular/common/http';
import { ParametroModel } from '../content/pages/components/configuracoes/parametros/parametro.model';

@Injectable({
  providedIn: 'root'
})
export class ParametroAdministrativoService extends GenericServicesMotoristaService {

  constructor(private _mensagensService: MensagensService,
    private _httpClient: HttpClient) {
    super();
  }
  getMensagensService(): MensagensService {
    return this._mensagensService;
  }

  getHttpClient(): HttpClient {
    return this._httpClient;
  }

  getUrlRecurso(): string {
    return '/parametroAdministrativo';
  }

  listarParametrosAdministrativo() {
    return this.get<ParametroModel[]>('/listar-parametros-administrativo');
  }

  salvarParametros(parametroModel: ParametroModel) {
    return this.post<ParametroModel>('/salvar', { dados: parametroModel });
  }
}
